import { useLogin } from '@bnnvara/accounts';
import React from 'react';

import { ProfileLoggedIn } from './ProfileLoggedIn';
import { ProfileLoggedOut } from './ProfileLoggedOut';

const Profile = () => {
  const { isLoggedIn, status } = useLogin();

  if (status === 'loading') return null;

  if (isLoggedIn) {
    return <ProfileLoggedIn />;
  }

  return <ProfileLoggedOut />;
};

export default Profile;
